/*
 * @Author: HTT httishere0728@gmail.com
 * @Date: 2023-06-15 21:53:33
 * @LastEditors: HTT httishere0728@gmail.com
 * @LastEditTime: 2023-06-15 21:55:04
 * @FilePath: /notion-widgets-site/src/utils/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const isMobile = () => {
    const info = navigator.userAgent;
    return /mobile/i.test(info);
}